<app-menu>
    <div class="grid-header">
      <div class="grid-title">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-envelope"></i>&nbsp;PCES Client Email List -->
        <button (click)="pcesClientLists()" style="background-color: rgb(244, 240, 245); color: black;" mat-raised-button color="primary">PCES CLIENT INFORMATION List</button> -->
        <button (click)="pcesEmailPendingLists()" style="background-color: rgb(244, 240, 245); color: black;" mat-raised-button color="primary">PCES EMAIL PENDING List</button><br><br>
        <mat-card-content>
          <div [formGroup]="search_email" style="display: flex ; justify-content: space-start; flex-wrap: wrap;">
              <span style="flex-basis: 100%; display: flex; justify-content: space-between;">
                  <mat-form-field style="width: 100%;">
                      <mat-label>Client Name:</mat-label>
                      <input matInput formControlName="clientname" placeholder="Start Typing...">
                  </mat-form-field>&nbsp;&nbsp;
                  <mat-form-field style="width: 100%;">
                    <mat-label>Email:</mat-label>
                    <input matInput formControlName="email" placeholder="Start Typing...">
                </mat-form-field>                  
              </span>
          </div>
          <div style="width: 50%; display: flex; justify-content: flex-start; gap: 20px">
              <!-- Search Button -->
              <button (click)="search()" mat-raised-button color="primary" style="background-color:rgb(21, 4, 117); font-size: 12px;">
                <i class="fa-solid fa-magnifying-glass"></i>
                <span class="text">Search</span>
              </button>
            
              <!-- Reset Button -->
              <button mat-raised-button (click)="resetFilter()"  mat-raised-button color="primary" style="background-color:rgb(21, 4, 117); font-size: 12px;">
                <i class="fas fa-undo"></i>
                <span class="text">Reset</span>
              </button>
            </div>
      </mat-card-content>           
      </div>
      <div class="toolbar-actions">
        <button (click)="createPCESCEmail()" style="background-color: rgb(125, 11, 160); " mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fa-solid fa-plus"></i>&nbsp;Add New Client Email
        </button>
      </div>       
      <div class="toolbar-actions">
        <div class="search-container" style="background-color: rgb(211, 213, 230); ">
          <div class="grid-title"><span style="text-align: center; font-size: 14px;">&nbsp;&nbsp;&nbsp;Upload Payment Stub Report</span><br></div>
          &nbsp;&nbsp;&nbsp;<button (click)="uploadPaymentReport()" style="background-color: rgb(2, 9, 71); " mat-raised-button color="primary">
            <i style="font-size: 15px;" class="fa-solid fa-upload"></i>&nbsp;Upload Payment Report
          </button>&nbsp;
        </div>
      </div>         
    </div>   
    <ag-grid-angular #agGrid
    style="width: 100%; height: 100%;"
    class="ag-theme-alpine"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [animateRows]="true"
    [rowData]="rowData"
    [rowModelType]="'serverSide'"
    [cacheBlockSize]="100"
    (gridReady)="onGridReady($event)"
    [detailCellRenderer]="detailCellRenderer"
    [masterDetail]="true" 
    [detailRowHeight]="350"
    >
    </ag-grid-angular>
  </app-menu>
  
